<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-wrapper">
      <mat-icon>check_circle</mat-icon>
      <div>
        {{ "kopetro.reviewApplication.approveApplication" | translate }}
      </div>
    </div>
    <mat-icon class="icon-close" (click)="onClose()">close</mat-icon>
  </div>

  <mat-divider></mat-divider>

  <div [innerHTML]="'kopetro.reviewApplication.approveDesc' | translate"></div>

  <div class="approve-container">
    <div class="field-item" *ngFor="let field of fieldList">
      <div class="label">{{ field.codeDesc | translate }}</div>
      <div class="value">{{ field.codeValue }}</div>
    </div>
  </div>

  <button
    mat-stroked-button
    type="button"
    class="approve-btn"
    (click)="onSubmit()"
  >
    {{ "common.submit" | translate }}
  </button>
</div>
